import {QueryField} from './query-field';
import {QueryFrom} from './query-from';
import {Querywhere} from './querywhere';

export class Query {
  fields: QueryField[] = [];
  from: QueryFrom[] = [];
  where: any;
}
